export const colors = {
    primary: "#011627",
    secondary: "#3b56a6",
    accent: "#ff3366",
    primaryTrim: "#d8e2dc",
    secondaryTrim: "#f6f7f8",
    base: "#ffffff",
}